/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tracking_Playback_StartInputs */

const vi_tracking_playback_start = /** @type {(inputs: Tracking_Playback_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Từ`)
};

/**

* @param {Tracking_Playback_StartInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const tracking_playback_start = /** @type {((inputs?: Tracking_Playback_StartInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tracking_Playback_StartInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_tracking_playback_start(inputs)
});